import Axios from "axios";
import { IGetCustomerWalletsInfoResponse, IGetWalletTransactionsResponse } from "../models/wallet.model";
import { ApiResultModel } from "../models/common.model";
import { APIBASE_URL, WALLET_URL } from "../config/cacheKey";

export const GetCustomerWalletsInfo = async (
): Promise<IGetCustomerWalletsInfoResponse[]> => {
    return await Axios.post<ApiResultModel<IGetCustomerWalletsInfoResponse[]>>(
        // SERVIES_URL
        APIBASE_URL + WALLET_URL + "/GetCustomerWalletsInfo",
    ).then((result) => {
        return result.data.data;
    });
};

export const GetCustomerWalletInfo = async (
    data: { walletKey: string }
): Promise<IGetCustomerWalletsInfoResponse> => {
    return await Axios.post<ApiResultModel<IGetCustomerWalletsInfoResponse>>(
        // SERVIES_URL
        APIBASE_URL + WALLET_URL + "/GetCustomerWalletInfo",
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetWalletTransactions = async (
    data: { walletKey: string }
): Promise<IGetWalletTransactionsResponse[]> => {
    return await Axios.post<ApiResultModel<IGetWalletTransactionsResponse[]>>(
        APIBASE_URL + WALLET_URL + "/GetWalletTransactions",
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetTotalBalance = async (): Promise<number> => {
    return await Axios.post<ApiResultModel<number>>(
        APIBASE_URL + WALLET_URL + "/GetTotalBalance",

    ).then((result) => {
        return result.data.data;
    });
};
